import { render } from "./manager_PlacementTest.vue?vue&type=template&id=4e403c38"
import script from "./manager_PlacementTest.vue?vue&type=script&lang=js"
export * from "./manager_PlacementTest.vue?vue&type=script&lang=js"

import "./manager_PlacementTest.vue?vue&type=style&index=0&id=4e403c38&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__